var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top"},[_c('a',{class:_vm.isScroll ? 'show' : '',attrs:{"id":"button"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }